import React, { useState } from "react";
import { BillForm } from "./BillForm";

export interface IBillCard {
  name: string;
  icon: React.ReactNode;
  category: string;
}

export const BillCard = ({ name, icon, category }: IBillCard) => {
  const [isFormModalOpen, setIsFormModalOpen] = useState<boolean>(false);

  return (
    <>
      <div
        className="bg-black border border-white/10 rounded-xl px-4 pt-6 pb-6 flex flex-col items-center cursor-pointer hover:border-primary/50 transition-all duration-200"
        onClick={() => setIsFormModalOpen(true)}
      >
        <div className="w-16 h-16 flex items-center justify-center text-primary text-4xl mb-4">
          {icon}
        </div>
        <p className="text-base text-white text-center font-medium">{name}</p>
      </div>

      <BillForm
        category={category}
        name={name}
        isFormModalOpen={isFormModalOpen}
        setIsFormModalOpen={setIsFormModalOpen}
      />
    </>
  );
};

